module.exports = __webpack_public_path__ + "media/img/help_center/Student_Academic_Profile_04-e322220d723cc830b98d5120dceba5cc.jpg";